import { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Card,
  Table,
  Button,
  Modal,
} from "react-bootstrap";

import { cmsNavigation } from "../../../components/cmsNavigation";
import { motion, AnimatePresence, LayoutGroup } from "framer-motion";
import { FiGlobe, FiHome, FiSettings } from "react-icons/fi";
import styled from "styled-components";
import image from "../../../assets/images/mainLogo.png";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import {
  getCountryList,
  getCityList,
  getStateList,
} from "../../../services/system.js";
import {
  onBoardOrganization,
  onBoardRegion,
  onBoardSite,
} from "../../../services/authentication.js";
import {
  getPlanList,
  getSystemServices,
  customUserPlan,
  createPlan,
  suscribe,
} from "../../../services/planServices";
import {
  callToast,
  showErrorMessages,
} from "../../../services/utilityFunctions";
import "../../../assets/css/onboarding.css";
import { getLocalStorageData } from "../../../services/axiosComponent";
import { DropdownIndicator } from "../../../views/dashboard/widget/tableWidget";
import ToggleSwitch from "../widget/toggleSwtich";
import { planColors } from "../../../services/constant";

export const GetAccessModalCustom = ({
  showModal,
  setShowModal,
  createPlanLoading,
  selectedServices,
  makeCustomPlans,
  systemServices,
  selectedPlan,
  customPlanData,
} = {}) => {
  var navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const suscribePlan = async () => {
    setLoading(true);
    var res = await suscribe({ planId: customPlanData?.["_ID"] });
    if (res.status == "success") {
      console.log(res, "res");
      localStorage.clear();
      navigate("/");
      setLoading(false);
      callToast("success", "Plan Subscribed Successfully");
      setShowModal(false);
    } else {
      showErrorMessages({ data: res.data, navigate });
    }
  };
  return selectedPlan == null ? null : (
    <Modal
      size="lg"
      container={document.body}
      show={showModal}
      onHide={() => setShowModal(false)}
      centered
      style={{
        borderRadius: "1.5rem",
      }}
      className="modern-pricing-modal"
    >
      <Modal.Body
        className="p-0"
        style={{
          backgroundColor: "transparent",
        }}
      >
        {createPlanLoading ? (
          <div className="d-flex justify-content-center align-items-center h-100">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <div
            className="modal-content-wrapper"
            style={{
              background: planColors[selectedPlan],
              borderRadius: "1.5rem",
              overflow: "hidden", // Ensures child elements don't exceed rounded corners
            }}
          >
            <button
              className="btn-close"
              onClick={() => setShowModal(false)}
              style={{
                position: "absolute",
                right: "1rem",
                top: "1rem",
                zIndex: 1,
                filter: "invert(1)",
              }}
            ></button>

            <div className="modal-grid-container">
              {/* Features Section */}
              <div className="features-section">
                <div className="feature-content">
                  <motion.h2
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="text-white mb-4 display-5 fw-bold"
                  >
                    Eazilite
                  </motion.h2>

                  <motion.p
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    className="text-white mb-5 lead"
                  >
                    Eazilite is a robust CMS designed to streamline management
                    for schools, hostels, and hotels. It simplifies daily
                    operations, resource allocation, and administrative tasks.
                    Experience seamless integration and smart automation to
                    elevate your institution's efficiency..
                  </motion.p>

                  <div className="features-list">
                    {systemServices.map((item, index) => {
                      const Icon = cmsNavigation.find(
                        (service) => service.title === item.NAME
                      )?.icon;
                      return selectedServices[index].selected ? (
                        <motion.div
                          key={index}
                          initial={{ opacity: 0, x: -20 }}
                          animate={{ opacity: 1, x: 0 }}
                          transition={{ delay: index * 0.1 }}
                          className="feature-item"
                        >
                          <div className="feature-icon">{<Icon />}</div>
                          <div className="feature-text">
                            <h4 className="mb-1">{item.NAME}</h4>
                            <p className="mb-0">{item.DESCRIPTION}</p>
                          </div>
                        </motion.div>
                      ) : null;
                    })}
                  </div>
                </div>
              </div>

              {/* Pricing Card */}
              <motion.div
                initial={{ scale: 0.9 }}
                animate={{ scale: 1 }}
                className="pricing-card"
              >
                <div className="price-content">
                  <div className="price-header">
                    <span className="price-badge">Special Offer</span>
                    <div className="price-amount">
                      <span className="currency">$</span>
                      <span className="number">
                        {makeCustomPlans[selectedPlan]?.["totalAmount"]}
                      </span>
                    </div>
                    <div className="price-description">
                      One-time payment • Seemless Access
                    </div>
                  </div>

                  <div className="price-benefits">
                    <div className="benefit-item">
                      <i className="bi bi-check2-circle"></i>
                      <span>No recurring charges</span>
                    </div>
                    <div className="benefit-item">
                      <i className="bi bi-check2-circle"></i>
                      <span>Priority support</span>
                    </div>
                  </div>

                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="purchase-button"
                    onClick={suscribePlan}
                    disabled={loading}
                  >
                    {loading ? (
                      <div className="d-flex align-items-center justify-content-center gap-2">
                        <div
                          className="spinner-border spinner-border-sm"
                          role="status"
                          style={{
                            color: planColors[selectedPlan],
                            opacity: 0.9,
                            width: "1rem",
                            height: "1rem",
                          }}
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                        <span style={{ opacity: 0.9 }}>Pay Now</span>
                      </div>
                    ) : (
                      "Pay Now"
                    )}
                    <i className="bi bi-arrow-right ms-2"></i>
                  </motion.button>
                </div>
              </motion.div>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export const GetAccessModalBase = ({
  showModal,
  setShowModal,
  systemServices,
  selectedPlan,
  plans,
} = {}) => {
  console.log(plans[selectedPlan], "selectedPlan");
  var navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const suscribePlan = async () => {
    setLoading(true);
    var res = await suscribe({ planId: plans[selectedPlan]?.["_ID"] });
    console.log(res, "res plan");
    if (res.status == "success") {
      localStorage.clear();
      navigate("/");
      setLoading(false);
      callToast("success", "Plan Subscribed Successfully");
      setShowModal(false);
    } else {
      showErrorMessages({ data: res.data, navigate });
    }
  };
  return selectedPlan == null ? null : (
    <Modal
      size="lg"
      container={document.body}
      show={showModal}
      onHide={() => setShowModal(false)}
      centered
      style={{
        borderRadius: "1.5rem",
      }}
      className="modern-pricing-modal"
    >
      <Modal.Body
        className="p-0"
        style={{
          backgroundColor: "transparent",
        }}
      >
        {
          <div
            className="modal-content-wrapper"
            style={{
              background: planColors[selectedPlan],
              borderRadius: "1.5rem",
              overflow: "hidden", // Ensures child elements don't exceed rounded corners
            }}
          >
            <button
              className="btn-close"
              onClick={() => setShowModal(false)}
              style={{
                position: "absolute",
                right: "1rem",
                top: "1rem",
                zIndex: 1,
                filter: "invert(1)",
              }}
            ></button>

            <div className="modal-grid-container">
              {/* Features Section */}
              <div className="features-section">
                <div className="feature-content">
                  <motion.h2
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="text-white mb-4 display-5 fw-bold"
                  >
                    {plans[selectedPlan]?.["NAME"]}
                  </motion.h2>

                  <motion.p
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    className="text-white mb-5 lead"
                  >
                    {plans[selectedPlan]?.["DESCRIPTION"]}
                  </motion.p>

                  <div className="features-list">
                    {plans[selectedPlan]["_SERVICES_"].map((item, index) => {
                      const Icon = cmsNavigation.find(
                        (service) => service.title === item.NAME
                      )?.icon;
                      return (
                        <motion.div
                          key={index}
                          initial={{ opacity: 0, x: -20 }}
                          animate={{ opacity: 1, x: 0 }}
                          transition={{ delay: index * 0.1 }}
                          className="feature-item"
                        >
                          <div className="feature-icon">
                            {" "}
                            {Icon ? <Icon /> : null}
                          </div>
                          <div className="feature-text">
                            <h4 className="mb-1">{item.NAME}</h4>
                            <p className="mb-0">{item.DESCRIPTION}</p>
                          </div>
                        </motion.div>
                      );
                    })}
                  </div>
                </div>
              </div>

              {/* Pricing Card */}
              <motion.div
                initial={{ scale: 0.9 }}
                animate={{ scale: 1 }}
                className="pricing-card"
              >
                <div className="price-content">
                  <div className="price-header">
                    <span className="price-badge">Special Offer</span>
                    <div className="price-amount">
                      <span className="currency">
                        {" "}
                        {plans[selectedPlan]?.["_CURRENCY SYMBOL"]}
                      </span>
                      <span className="number">
                        {plans[selectedPlan]?.["AMOUNT"]}
                      </span>
                    </div>
                    <div className="price-description">
                      One-time payment • Seemless Access
                    </div>
                  </div>

                  <div className="price-benefits">
                    <div className="benefit-item">
                      <i className="bi bi-check2-circle"></i>
                      <span>No recurring charges</span>
                    </div>
                    <div className="benefit-item">
                      <i className="bi bi-check2-circle"></i>
                      <span>Priority support</span>
                    </div>
                  </div>

                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="purchase-button"
                    onClick={suscribePlan}
                    // disabled={loading}
                  >
                    {loading ? (
                      <div className="d-flex align-items-center justify-content-center gap-2">
                        <div
                          className="spinner-border spinner-border-sm"
                          role="status"
                          style={{
                            color: planColors[selectedPlan],
                            opacity: 0.9,
                            width: "1rem",
                            height: "1rem",
                          }}
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                        <span style={{ opacity: 0.9 }}>Getting Access...</span>
                      </div>
                    ) : (
                      "Get Access"
                    )}
                    <i className="bi bi-arrow-right ms-2"></i>
                  </motion.button>
                </div>
              </motion.div>
            </div>
          </div>
        }
      </Modal.Body>
    </Modal>
  );
};
